"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhone = formatPhone;
function formatPhone(value) {
  let phoneNumbers = value.replace(/\D+/g, '');
  if (phoneNumbers.length === 10) {
    phoneNumbers = `8${phoneNumbers}`;
  }
  return phoneNumbers.replace(/^8|\+7|7/, '+7');
}